import { render, staticRenderFns } from "./deleteIcon.vue?vue&type=template&id=012e3418&"
import script from "./deleteIcon.vue?vue&type=script&lang=js&"
export * from "./deleteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports